import { motion } from 'framer-motion';

const containerVariants = {
    animate: {
        transition: {
            staggerChildren: 0.15,
        },
    },
};

const dotVariants = {
    initial: { y: 0 },
    animate: {
        y: [0, -5, 0],
        transition: {
            duration: 1,
            ease: 'easeInOut' as const,
            repeat: Number.POSITIVE_INFINITY,
        },
    },
};

export function LoadingDots() {
    return (
        <motion.div
            variants={containerVariants}
            initial='initial'
            animate='animate'
            className='flex items-center justify-center gap-1.5'
        >
            <motion.span className='h-1.5 w-1.5 rounded-full bg-gray-400' variants={dotVariants} />
            <motion.span className='h-1.5 w-1.5 rounded-full bg-gray-400' variants={dotVariants} />
            <motion.span className='h-1.5 w-1.5 rounded-full bg-gray-400' variants={dotVariants} />
        </motion.div>
    );
}
